<form [formGroup]="eHailingDriverNameForm">

    <div nxRow>
        <div nxCol="12">
            <h4 class="nx-margin-0">e-Hailing Drivers Name</h4>
        </div>
    </div>

    @if(rows.controls.length > 0) {
    <div nxRow>
        <div nxCol="12" class="driver_list">
            <div class="nx-margin-top-m">
                <app-external-scrollbar targetSyncScroll="1"
                              [targetBaseWidth]="tableHolder1"></app-external-scrollbar>
                <div class="table-holder table_content_scroll only-this-horizon-scrollbar" #tableHolder1 syncScroll="1">
                    <table nxTable aria-label="namedDriverTableDesc">
                        <thead>
                            <tr nxTableRow>
                                <th nxHeaderCell></th>
                                <th nxHeaderCell>Driver Name</th>
                                <th nxHeaderCell>Driver ID</th>
                                @if(isEndorsement) {
                                    <th nxHeaderCell></th>
                                }
                            </tr>
                        </thead>
                        <tbody formArrayName="rows">
                            @for (row of rows.controls; track row) {
                            <tr nxTableRow [formGroupName]="$index">
                                <td nxTableCell>{{ $index + 1 }}</td>
                                <td nxTableCell>
                                    <nx-formfield appearance="outline">
                                        <input formControlName="driverName" maxlength="100" nxInput (blur)="onChangeForm($index)"  appToUpperCase />
                                        <nx-error nxFormfieldError>Driver Name is required.</nx-error>
                                    </nx-formfield>
                                </td>
                                <td nxTableCell>
                                    <nx-formfield appearance="outline" class="driver_id">
                                        <input formControlName="driverId" maxlength="20" nxInput (blur)="onChangeForm($index)"  appToUpperCase appAlphaNumeric/>
                                        <nx-error nxFormfieldError>Driver ID is required.</nx-error>
                                    </nx-formfield>
                                </td>
                                @if(isEndorsement){
                                <td nxTableCell>
                                    <button nxPlainButton type="button" class="nx-margin-left-m" (click)="deleteDriver($index)">
                                        <nx-icon name="trash-o" size="s"></nx-icon>
                                    </button>
                                </td>
                                }
                            </tr>
                            }

                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    }

    @if(isEndorsement){
    <div nxRow class="nx-margin-top-m nx-margin-bottom-2m">
        <div nxCol="12">
            <button nxPlainButton type="button" class="nx-margin-right-m" [disabled]="true">
                <nx-icon name="plus" nxIconPositionStart aria-hidden="true"></nx-icon>ADD DRIVER
            </button>
        </div>
    </div>
    }

</form>